const WHATSAPP_URL = "https://wa.me/5511989666465";
const IG_URL = "https://instagram.com/triadmarketing.ads";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-ink-950 py-16 md:py-20">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-6">
            <div className="flex items-center gap-4">
              <img
                src="/triad-logo.png"
                alt="Triad Marketing"
                className="h-16 md:h-20 w-auto object-contain"
                style={{
                  filter: "drop-shadow(0 0 20px rgba(107, 138, 255, 0.35))",
                }}
              />
            </div>
            <p className="mt-5 text-white/50 max-w-md text-sm leading-relaxed">
              Gestão de perfil, tráfego pago e conteúdo para marcas que querem crescer com estratégia.
            </p>
          </div>

          <div className="col-span-12 md:col-span-6">
            <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">Contato</div>
            <ul className="space-y-2 text-white/70 text-sm font-light md:text-right">
              <li>
                <a data-testid="footer-whatsapp" href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="hover:text-blue transition-colors">
                  WhatsApp — (11) 98966-6465
                </a>
              </li>
              <li>
                <a data-testid="footer-instagram" href={IG_URL} target="_blank" rel="noreferrer" className="hover:text-blue transition-colors">
                  Instagram — @triadmarketing.ads
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-[10px] uppercase tracking-[0.3em] text-white/40">
          © {new Date().getFullYear()} Triad Marketing.
        </div>
      </div>
    </footer>
  );
}
